module.exports = __webpack_public_path__ + "img/lanli-logo-light.738a8d52.png";